import { apolloClient } from "../../vue-apollo";
import {
    GET_BIRTHDATE,
    GET_BIRTHDAY
} from "../../graphql/queries";
import {

} from "../../graphql/mutations";

export default {
    namespaced: true,
    state: {
        birthdaysDates: [],
        birthdaysDays: []
        
    },
    getters: {
    },
    mutations: {
        SET_BIRTHDATES(state, cumple){
            state.birthdaysDates = cumple;
        },

        SET_BIRTHDAYS(state, days){
            state.birthdaysDays = days;
        }
    },
    actions: {
        async getBirthDate({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_BIRTHDATE,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getBirthDate: ", res.data.birthdaysDates);
                if (!res.loading) response = res.data.birthdaysDates;
            });
            }
            catch(e){
            console.log("Falla error, birthdaysDates ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                        commit("SET_BIRTHDATES", []);
                    }
                    else {
                        resolve(response);
                        commit("SET_BIRTHDATES", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
            
        },

        async getBirthDay({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_BIRTHDAY,
                variables: data_
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getBirthDay: ", res.data.birthdaysDays);
                if (!res.loading) response = res.data.birthdaysDays;
            });
            }
            catch(e){
            console.log("Falla error, getBirthDay ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        resolve(false);
                        commit("SET_BIRTHDAYS", []);
                    }
                    else {
                        resolve(response);
                        commit("SET_BIRTHDAYS", response);
                    }
                }
                else {
                    resolve(false);
                }
            });
            
            
        },
        

    }
};